import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { TruncatedFragment } from 'site-modules/shared/components/truncated-fragment/truncated-fragment';

import './truncated-html.scss';

export function TruncatedHtml({
  entry,
  minHeight = 0,
  contentClassName = null,
  btnContainerClassName = 'mt-1',
  btnTextClassName = 'text-primary-darker',
  expandText = 'See more',
  collapseText = 'See less',
  isTruncated = true,
}) {
  const title = entry.metadata('title').value();
  const TitleTag = entry.metadata('titleTag').value('div');
  const disableCollapse = entry.hasMetadata('collapsible') && !entry.metadata('collapsible').boolean();

  return (
    <Fragment>
      {/* eslint-disable-next-line react-hooks/static-components -- TitleTag is a CMS-configured stable HTML tag string */}
      {!!title && <TitleTag className="heading-3 mb-0_5">{title}</TitleTag>}
      <TruncatedFragment
        content={entry.metadata('htmlContent').value()}
        contentClassName={contentClassName}
        btnContainerClassName={btnContainerClassName}
        btnTextClassName={btnTextClassName}
        expandText={expandText}
        collapseText={collapseText}
        btnTrackingId="best_vehicle_see_more"
        minHeight={minHeight}
        isTruncated={isTruncated && !disableCollapse}
        isHtml
      />
    </Fragment>
  );
}

TruncatedHtml.propTypes = {
  entry: CmsEntities.Content.isRequired,
  contentClassName: PropTypes.string,
  btnContainerClassName: PropTypes.string,
  btnTextClassName: PropTypes.string,
  expandText: PropTypes.string,
  collapseText: PropTypes.string,
  minHeight: PropTypes.number,
  isTruncated: PropTypes.bool,
};
